import React from "react";
import { Switch as SwitchReact } from "@headlessui/react";
import { twMerge } from "tailwind-merge";

type SwitchProps = {
  className?: string;
  value: boolean;
  setValue: (value: boolean) => void;
  /** Accessible name. Required in practice: the thumb is aria-hidden, so without it the control is unnamed. */
  ariaLabel: string;
  disabled?: boolean;
};

const Switch: React.FC<SwitchProps> = ({ className, value, setValue, ariaLabel, disabled = false }: SwitchProps) => (
  <div className={`inline-flex shrink-0 ${className}`}>
    <SwitchReact
      checked={value}
      onChange={setValue}
      aria-label={ariaLabel}
      disabled={disabled}
      className={`relative inline-flex h-6 w-12 cursor-pointer rounded-full border-2 border-transparent outline-none transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-brandPurple-300 focus-visible:ring-offset-2 focus-visible:ring-offset-n-700 motion-reduce:transition-none disabled:cursor-not-allowed disabled:opacity-50 ${
        value ? "bg-brandPurple-500" : "bg-n-300 dark:bg-n-500"
      }`}
    >
            <span
              aria-hidden="true"
              className={twMerge(
                `pointer-events-none inline-block h-5 w-5 rounded-full bg-n-100 transition-transform duration-200 motion-reduce:transition-none dark:bg-n-700 ${
                  value ? "translate-x-6 dark:bg-n-100" : "translate-x-0"
                }`
              )}
            />
    </SwitchReact>
  </div>
);

export default Switch;
